import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import allTestsAreFailed from '../../../../../assets/image/all-tests-are-failed.svg'
import testsPassed from '../../../../../assets/image/tests-passed.png'
import testsFailed from '../../../../../assets/image/tests-failed.png'
import Button from '../../../../../components/UI/Button'

import {
  setActiveCategory,
  setActiveCategoryIndex,
} from '../../../../../routing/fetchingfunction/user/user.action'

import { testPassedStatuses } from 'constants'

const MyClassCategoriesTestResults = ({ passedStatus, testName, onContinue, onCancel }) => {
  const dispatch = useDispatch()

  // TODO compare lastPassedCategory index and selectedCategories.length - 1 to know what is the next step
  const { activeCategoryIndex, selectedCategories, passedTests } = useSelector(
    (state) => state.user
  )

  const areAllTestsFailed =
    passedTests.every((test) => test.test.is_passed === false) &&
    passedTests.length === selectedCategories.length

  const handleContinue = () => {
    if (areAllTestsFailed || passedStatus === testPassedStatuses.FAILED_ALL) {
      return onCancel()
    }

    if (activeCategoryIndex === selectedCategories.length - 1) {
      onContinue(1)
    } else {
      onContinue(-1)

      dispatch(setActiveCategoryIndex(activeCategoryIndex + 1))
      dispatch(setActiveCategory(selectedCategories[activeCategoryIndex + 1]))
    }
  }

  const handleRenderNextButton = () => (
    <Button variant="primary" onClick={handleContinue} className="shadow-button-dark">
      {areAllTestsFailed ? 'Back to My Category Settings' : resultsContent.nextStep}
    </Button>
  )

  const resultsContent = useMemo(() => {
    switch (passedStatus) {
      case testPassedStatuses.PASSED_ALL:
        return {
          title: 'Congratulations!',
          description: 'All Tests have been passed successfully!',
          nextStepText: "Now you're able to setup your class.",
          nextStep: 'Go to "Setup Class"',
          passed: true,
        }
      case testPassedStatuses.PASSED_PARTIAL:
        return {
          title: 'Congratulations!',
          description: `${testName ? `${testName} ` : ''}Test Successfully Passed!`,
          nextStepText: "Let's continue to the next test.",
          nextStep: 'Continue',
          passed: true,
        }
      case testPassedStatuses.FAILED_ALL:
        return {
          title: `Oops!`,
          description: `You Failed All Category Tests.`,
          nextStepText: 'You can try this test again after 30 days.',
          nextStep: 'Back to My Category Settings',
          passed: false,
        }
      case testPassedStatuses.FAILED_PARTIAL:
        return {
          title: `Unfortunately, you have failed the${testName ? ` ${testName}` : ''} test.`,
          nextStepText:
            'You can try these tests again in 30 days. Let’s continue and complete the remaining tests.',
          nextStep: 'Continue',
          passed: false,
        }
      default:
        return {
          title: 'Test Results',
          nextStepText: 'Continue',
          nextStep: 'Continue',
          passed: false,
        }
    }
  }, [passedStatus, testName])

  return (
    <div className="max-w-[800px] mx-auto">
      <div className="flex flex-col items-center justify-start !text-white-50">
        {areAllTestsFailed && 'You Failed All Tests.'}

        <h3 className={`${areAllTestsFailed ? 'text-5xl' : 'text-4xl'} text-center font-bold`}>
          {areAllTestsFailed ? 'We are sorry you have failed all test.' : resultsContent.title}
        </h3>

        {areAllTestsFailed ? (
          <h4 className="mt-3 font-medium">
            We will send an email in 30 days so you can take the test again.
          </h4>
        ) : (
          resultsContent.description && (
            <h4 className="text-2xl mb-3">{resultsContent.description}</h4>
          )
        )}

        {!areAllTestsFailed && <p className="mb-4">{resultsContent.nextStepText}</p>}

        {areAllTestsFailed ? (
          <div className="my-[50px]">
            <img className="block" src={allTestsAreFailed} alt="All tests are failed" />
          </div>
        ) : (
          <div className="!mb-5">
            {resultsContent.passed ? (
              <img className="block" src={testsPassed} alt="Passed" />
            ) : (
              <img className="block" src={testsFailed} alt="Failed" />
            )}
          </div>
        )}

        {passedStatus === testPassedStatuses.PASSED_ALL ? (
          <div className="w-[300px] flex flex-col">
            {handleRenderNextButton()}

            {passedStatus === testPassedStatuses.PASSED_ALL && (
              <Button variant="secondary" onClick={onCancel} className="!mt-[20px] !font-semibold">
                Back to My Category Settings
              </Button>
            )}
          </div>
        ) : (
          handleRenderNextButton()
        )}
      </div>
    </div>
  )
}

export default MyClassCategoriesTestResults
